import LegalPage from './LegalPage';
import { COMPANY, SHIPPING_COUNTRIES_ONLINE } from './legalConstants';

export default function Verzending() {
  return (
    <LegalPage title="Verzending & levering" testId="legal-page-shipping">
      <h2>1. Online leverlanden</h2>
      <p data-testid="shipping-online-countries-intro">
        Onze online bestelling is bestemd voor klanten in de volgende
        landen:
      </p>
      <ul data-testid="shipping-online-countries-list">
        {SHIPPING_COUNTRIES_ONLINE.map(c => (
          <li key={c.code}>
            <strong>{c.name_nl}</strong> ({c.code})
          </li>
        ))}
      </ul>
      <p data-testid="shipping-other-eu-note">
        Voor leveringen naar andere Europese landen vragen wij u
        vooraf contact op te nemen via{' '}
        <a href={`mailto:${COMPANY.email}`} className="underline">
          {COMPANY.email}
        </a>
        . Wij bevestigen de bestelling pas na overleg over
        verzendingskosten, beschikbaarheid en eventuele bijkomende
        formaliteiten.
      </p>
      <p data-testid="shipping-non-eu-note">
        Leveringen buiten de Europese Unie zijn niet beschikbaar
        via de standaard checkout en kunnen enkel na uitdrukkelijke
        manuele bevestiging.
      </p>

      <h2>2. Leveringsmethode</h2>
      <p>
        Voor leveringen in <strong>België</strong> bieden wij standaard{' '}
        <strong>thuislevering</strong> aan en — wanneer dit in de
        checkout zichtbaar is — ook levering in een{' '}
        <strong>bpost-afhaalpunt</strong> of{' '}
        <strong>bpost-pakjesautomaat</strong>. U kiest zelf welke
        optie u verkiest tijdens het afrekenen.
      </p>
      <p>
        Voor leveringen naar <strong>Nederland</strong>,{' '}
        <strong>Frankrijk</strong> en <strong>Luxemburg</strong> is
        momenteel enkel thuislevering beschikbaar. Bpost-afhaalpunten
        en -pakjesautomaten zijn vandaag enkel beschikbaar voor
        Belgische bestemmingen.
      </p>
      <p data-testid="shipping-pickup-fallback-note">
        Als afhaalpunt- of pakjesautomaat-keuze tijdelijk niet
        beschikbaar is in de checkout (bijvoorbeeld bij een tijdelijke
        storing bij bpost), kunt u steeds verder bestellen met
        thuislevering.
      </p>

      <h2>3. Leveringskosten</h2>
      <p>
        De leveringskosten worden duidelijk weergegeven in de checkout
        vóór u uw bestelling bevestigt. Eventuele drempels voor gratis
        verzending zijn op datzelfde scherm zichtbaar.
      </p>

      <h2>4. Leveringstermijn</h2>
      <p>
        Bestellingen die op een werkdag vóór het ophaaltijdstip van
        onze logistieke partner zijn betaald, worden in principe
        binnen <strong>2 tot 5 werkdagen</strong> in België geleverd.
        Leveringen naar Nederland, Frankrijk en Luxemburg kunnen iets
        langer duren afhankelijk van de vervoerder. Tijdens
        piekperiodes of bij overmacht (weersomstandigheden, staking,
        enz.) kan deze termijn afwijken.
      </p>

      <h2>5. Niet-thuis bij levering</h2>
      <p>
        Indien u niet aanwezig bent op het leveringsadres, volgt de
        procedure van de vervoerder (bpost): een melding in de
        brievenbus en/of een tweede leveringspoging, gevolgd door
        bewaring in een afhaalpunt voor afhaling binnen de door
        bpost bepaalde termijn.
      </p>

      <h2>6. Niet-conforme of beschadigde levering</h2>
      <p>
        Controleer uw bestelling bij ontvangst. Bij beschadiging of
        afwijking neemt u binnen 7 dagen contact op met{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> met
        zo veel mogelijk informatie (bestelnummer, foto&apos;s,
        beschrijving). Wij zoeken een passende oplossing.
      </p>

      <h2>7. Adresgegevens</h2>
      <p>
        Zorg ervoor dat het leveringsadres correct en volledig is.
        Indien een levering mislukt door een onjuist adres, kunnen
        eventuele extra verzendkosten doorgerekend worden.
      </p>
    </LegalPage>
  );
}
